import { render, staticRenderFns } from "./CommonCard.vue?vue&type=template&id=db5ff1ca&scoped=true&"
import script from "./CommonCard.vue?vue&type=script&lang=js&"
export * from "./CommonCard.vue?vue&type=script&lang=js&"
import style0 from "./CommonCard.vue?vue&type=style&index=0&id=db5ff1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5ff1ca",
  null
  
)

export default component.exports